export default "* Sæl\n* Farver\n* Aftegninger\n* Unik";